import { features } from '../../data/homepageData';

export function FeatureStrip() {
  return (
    <section id="about" className="feature-strip section--compact">
      <h2>Proč Calendar Studio</h2>
      <div className="feature-grid">
        {features.map(({ icon: Icon, title, text }) => (
          <article className="feature-card" key={title}>
            <Icon size={24} />
            <h3>{title}</h3>
            <p>{text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
